import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ElementRef, HostListener } from "@angular/core";
import { OwlOptions, CarouselComponent } from 'ngx-owl-carousel-o';
import { AppService } from "src/app/services/services";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Modal } from 'bootstrap';
import { EncryptionService } from "src/app/services/encryption.service";
import { animate, state, style, transition, trigger } from "@angular/animations";
import { ErrorModalComponent } from "src/app/common/error-modal/error-modal.component";

@Component({
    selector: 'nri-app-segments',
    templateUrl: './segments.component.html',
    styleUrls: ['./segments.component.scss'],
    animations: [
        trigger('toggle', [
            state('true', style({ opacity: 1 })),
            state('void', style({ opacity: 0 })),
            transition(':enter', animate('500ms ease-in-out')),
            transition(':leave', animate('500ms ease-in-out'))
        ])
    ]
})

export class SegmentsComponent implements OnInit {
    @ViewChild('foimg') foimgError: ElementRef;
    @ViewChild('owlCar') owlCar: CarouselComponent;
    bankstatement: any;
    terms: string = '';
    customOptions: OwlOptions = {
        loop: false,
        margin: 10,
        autoplay: false,
        dots: false,
        navSpeed: 700,
        navText: ['<img src="./assets/images/arrow-left.png" height="24">', '<img src="./assets/images/arrow-right.png" height="24">'],
        responsive: {
            0: {
                items: 1
            },
            480: {
                items: 2
            },
            940: {
                items: 3
            }
        },
        nav: true
    }
    disableAll: boolean = false;
    docError: boolean = true;
    docTypeList: any;
    equity: string = 'Equity';
    erefNo: string = '';
    futureOption: any;
    foType: any;
    foUpdt: boolean = false;
    foImgempty: boolean;
    mutualFund: string = 'MF';
    myModal: any;
    trade: any;
    mitc: any;
    pdfModal: any;
    productList: any;
    promoCode: string = '';
    psArray: any = 0;
    hideImage: boolean = false;
    hidePromo: boolean;
    productAction: boolean;
    selectedProductID: any = '';
    freedomPlan: boolean;
    promoFailed: boolean;
    promoDone: boolean;
    promoSuccess: boolean;
    foChecked: boolean = false;
    appliedPromo: string = '';
    pdffile: any;
    reStatus: any;
    mutualFunds: boolean = true;
    stamp: boolean;
    imgChange: boolean = false;
    selectedIndex: number = -1;
    moreDet: boolean = false;
    moreDetailsList: any = [];
    @ViewChild('errorComp') errorComp: ErrorModalComponent;
    dematType: string = "";
    IndianCT: boolean = true;
    MITCTerms: boolean = true;
    NRO: string = '';
    termsStage: boolean = false;
    politically: boolean = true;
    Preferences: boolean = true;
    settled: boolean = true;
    FundSettleDays: string = 'D';
    isMobile: boolean = false;
    autoCredit: string = 'Y';
    Pledge: string = 'N';
    DIS: string = 'Y';
    tDDPI: string = 'Y';
    FirstHold: string = 'Y';
    SecondHold: string = 'N';
    ThreeHold: string = 'N';
    ECS: string = 'Y';
    BSDA: string = 'N';
    tSEBI: string = 'Monthly';
    tRTA: string = 'Y';
    TElectronic: string = 'Physical';
    equityChecked: boolean = true;
    constructor(public _http: AppService, private http: EncryptionService, private router: Router, private toastr: ToastrService, private loader: NgxUiLoaderService) {
        this._http.getRefNum().subscribe(data => {
            this.erefNo = data;
        });
        this._http.getStatus().subscribe(data => {
            if (data.ReStatus === 'FN') {
                this.reStatus = data.ReStatus;
            } else {
                this.reStatus = data.ReStatus;
            }
            // if(data.Stamp === true){
            //     this.mutualFunds = false;
            //     this.mutualFund = "";
            // }else{
            //     this.mutualFunds = true;
            //     this.mutualFund = "MF";
            // }
        })

        // this._http.getMutualFund().subscribe(data => {
        //     if(data.mutualFund == true){
        //         this.mutualFunds = true;
        //     }else{
        //         this.mutualFunds = false;
        //     }
        // })
    }
    ngOnInit() {
        this._http.scroll();
         if (/Android|webOS|iPhone|iPad|iPod|pocket|psp|kindle|avantgo|blazer|midori|Tablet|Palm|maemo|plucker|phone|BlackBerry|symbian|IEMobile|mobile|ZuneWP7|Windows Phone|Opera Mini/i.test(navigator.userAgent)) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
        this.overallStatus()
        this._http.getMasters().subscribe(data => {
            if (data && data.DocumentTypeList) {
                this.docTypeList = data.DocumentTypeList;
                this.docTypeList = data.DocumentTypeList.filter((e: any) => {
                    return e.DocumentCategory === 4;
                })
            }
        });
        this.getProductLists();
        this.getProuctStage();
        this.prdSelect(0, "event");
    }

    overallStatus() {
        let url = 'DIY/DIYOverallStatus';
        this.loader.start();
        let checkSum = this.erefNo;
        let params = {
            'ReferenceNumber': this.erefNo,
        }
        this._http.httpPost(url, params, checkSum).subscribe({
            next: (data: any) => {
                this.loader.stop();
                let overAllVal = this.http.decryptUsingAES256(data.OutPut)
                if (overAllVal && overAllVal.IsSuccess) {
                    let item = overAllVal.overallLists;
                    this.stamp = overAllVal.StampRequired;
                    this.NRO = overAllVal.NRO;
                    if (this.NRO === 'N') {
                        this.termsStage = false;
                    }

                    //   console.log(this.stamp,"stamp");
                }

            },
            error: _error => {
                this.loader.stop();
                // this.toastr.error(_error.error.Message)
                this.errorComp.ModalShow(_error.error.Message);
            }
        })
    }

    getProductLists() {
        let url = "DIY/DIYGetProducts";
        this.loader.start();
        let params = {
            "ReferenceNumber": this.erefNo,
            "BusinessType": "DIY"
        }
        let checkSum = this.erefNo + 'DIY';

        this._http.httpPost(url, params, checkSum).subscribe({
            next: (data: any) => {
                this.loader.stop();
                let productVal = this.http.decryptUsingAES256(data.OutPut)
                if (productVal && productVal.productLists.length !== 0) {
                    this.productList = productVal.productLists;
                    if(this.productList[0].MF==='N' && this.NRO === 'Y'){
                        this.equityChecked = false;
                    }  
                    this.productList.forEach((element: any, i: any) => {
                        if (element.DefaultProduct) {
                            this.selectedProductID = element.ProductId;

                            setTimeout(() => {
                                this.owlCar.to(this.selectedProductID.toString())
                            }, 500)
                            this.prdSelect(i);
                            // this.getProuctStage();
                        }
                    });
                }
            }, error: _error => {
                this.loader.stop();
                // this.toastr.error(_error.error.Message)
                this.errorComp.ModalShow(_error.error.Message);
            }
        })
    }

    getProuctStage() {
        let url = 'DIY/DIYGetUpdtProduct';
        this.loader.start();
        let params = {
            "ReferenceNumber": this.erefNo
        }

        let checkSum = this.erefNo;

        this._http.httpPost(url, params, checkSum).subscribe({
            next: (data: any) => {
                this.loader.stop();
                let updtProductVal = this.http.decryptUsingAES256(data.OutPut)
                if (updtProductVal && updtProductVal.IsSuccess) {
                    if (updtProductVal.ProductId) {
                        this.selectedProductID = updtProductVal.ProductId;
                        this.terms = 'terms';
                        setTimeout(() => {
                            this.owlCar.to(this.selectedProductID.toString())
                        }, 500)

                        setTimeout(() => {
                            this.productList.forEach((element: any, i: any) => {
                                if (element.ProductId === this.selectedProductID) {
                                    this.prdSelect(i, "event");
                                }
                            });
                        }, 500);




                        if (updtProductVal.PromoCode) {
                            this.promoCode = updtProductVal.PromoCode;
                            this.appliedPromo = updtProductVal.PromoCode;
                        }

                        if (updtProductVal.NSEEquityFandO === 'Y') {
                            this.foChecked = true;
                            this.futureOption = 'F&O';
                        }
                        if (updtProductVal && (updtProductVal.NSEMutualFunds === 'Y' || updtProductVal.BSEMutualFunds === 'Y')) {
                            this.mutualFund = "MF";
                            this.mutualFunds = true;
                        }
                        if (updtProductVal.DematType) {
                            this.dematType = updtProductVal.DematType;
                        }
                    }
                }
            },
            error: _error => {
                this.loader.stop();
                //   this.toastr.error(_error.error.Message)
                this.errorComp.ModalShow(_error.error.Message);
            }
        })
    }

    moreDetails(list: any) {
        if (list) {
            this.moreDet = true;
            this.moreDetailsList = list;
        }
    }

    segmentChange(event: any) {
        if (event.target.id === 'fo') {
            if (event.target.checked) {
                this.foChecked = true;
                // const element = document.getElementById('myModal') as HTMLElement;
                // this.myModal = new Modal(element, {backdrop: 'static', keyboard: false});
                // this.myModal.show();
            } else {
                this.foChecked = false;
            }
        }
        // if(this.stamp === true){
        //     if(this.stamp === true && this.foChecked === true){
        //         this.mutualFund = "MF";
        //         this.mutualFunds = true;
        //     }else{
        //         this.mutualFund = "MF";
        //         this.mutualFunds = false;
        //     }
        // }

    }

    decline() {
        this.foChecked = false;
        this.futureOption = '';
        this.myModal.hide();
        // if(this.stamp === true && this.foChecked === false){
        //     this.mutualFund = "";
        //     this.mutualFunds = false;
        // }
    }

    imageURL(event: any) {
        if (event.url) {
            this.foUpdt = true;
            this.foImgempty = false;
        }
    }

    prdSelect(i: any, event?: MouseEvent | string) {
        this.psArray = i;
        this.selectedIndex = i;
        if (this.selectedIndex === i && event) {
            this.hideImage = true;
        }
        else {
            this.hideImage = false;
        }
        setTimeout(() => {
            if (this.productList[i].OpeningFee == 0 || !this.productList[i].OpeningFee) {
                this.hidePromo = true;
            } else {
                this.hidePromo = false;
            }
            if (this.productList[i].ProductUIType == 1) {
                this.productAction = false;
            } else {
                this.productAction = true;
            }
            this.promoSuccess = false;
            this.promoDone = false;
            this.promoFailed = false;
            this.selectedProductID = this.productList[i].ProductId;

            if (this.productList[i].Isfreedomplan) {
                this.freedomPlan = true;
                this.hidePromo = true;
            } else {
                this.freedomPlan = false;
                this.hidePromo = false;
                this.promoCode = '';
            }
            this.productSelect(this.productList[i].ProductId);
        }, 1000);

    }

    productSelect(id: string) {

    }

    applyPromo() {
        let url = 'DIY/ApplyPromoCode';
        let params = {
            "ReferenceNumber": this.erefNo,
            "PromoCode": this.promoCode,
            "ProductId": this.selectedProductID
        }

        let checkSum = this.erefNo + this.promoCode + this.selectedProductID;

        this._http.httpPost(url, params, checkSum).subscribe({
            next: (data: any) => {
                let promoCode = this.http.decryptUsingAES256(data.OutPut);
                if (promoCode && promoCode.IsSuccess) {
                    // this.toastr.success(promoCode.Success);
                    // this.errorComp.ModalShow(promoCode.Success);
                    this.appliedPromo = this.promoCode;
                } else {
                    // this.toastr.error(promoCode.Error);
                    this.errorComp.ModalShow(promoCode.Error);
                }
            },
            error: e => {
                // this.toastr.error(e.error.Message)
                this.errorComp.ModalShow(e.error.Message);
            }
        })
    }

    stageValidate() {
        if(!this.dematType){
            this.errorComp.ModalShow("Please select the Depository");
            return;
        }
        if (!this.IndianCT && this.NRO === 'Y') {
            this.errorComp.ModalShow("Please accept the terms and conditions");
            return;
        }
        if (!this.selectedProductID) {
            // this.toastr.error("Please Select the Product");
            this.errorComp.ModalShow("Please Select the Product");
            return;
        }
        if (this.foChecked && !this.foUpdt) {
            // this.toastr.error('Please upload income proof');
            this.errorComp.ModalShow("Please upload income proof");
        } else {
            if (this.foChecked === true) {
                this._http.setBank({
                    FandO: true,
                })
            } else {
                this._http.setBank({
                    FandO: false,
                })
            }

            this.loader.start();
            let url = "DIY/DIYUpdtProduct";

            let params = {
                "ReferenceNumber": this.erefNo,
                "Equity": true,
                "Derivative": false,
                "Commodity": false,
                "ProductId": this.selectedProductID,
                "AssistLGCode": "",
                "AssistLCCode": "",
                "BSEEquityCash": "Y",
                "NSEEquityCash": "Y",
                "MCXEquityCash": "N",
                "BSEEquityFandO": "N",
                "NSEEquityFandO": this.foChecked ? 'Y' : 'N',
                "MCXEquityFandO": "N",
                "BSECurrencyFandO": "N",
                "NSECurrencyFandO": this.foChecked ? 'Y' : 'N',
                "MCXCurrencyFandO": "N",
                "BSEMutualFunds": this.mutualFunds ? "Y" : "N",
                "NSEMutualFunds": this.mutualFunds ? "Y" : "N",
                "MCXMutualFunds": "N",
                "BSECommodity": "N",
                "NSECommodity": "N",
                "MCXCommodity": "N",
                "NCDXCommodity": "N",
                "NCDXEquityCash": "N",
                "NCDXEquityFandO": "N",
                "NCDXCurrencyFandO": "N",
                "NCDXMutualFunds": "N",
                "SLB": "Y",
                "PromoCode": this.appliedPromo,
                "DematType": this.dematType? this.dematType:"CDSL"
            }

            let checkSum = this.erefNo + 'NSDL';

            this._http.httpPost(url, params, checkSum).subscribe({
                next: (data: any) => {
                    let stageVal = this.http.decryptUsingAES256(data.OutPut)
                    this.loader.stop();
                    if (stageVal && stageVal.IsSuccess) {
                        // this.toastr.success(stageVal.Success);
                        // this.errorComp.ModalShow(stageVal.Success);
                        if(this.NRO === 'Y'){
                            this.router.navigate(['/signature'], { replaceUrl: true });
                        }else{
                            this.router.navigate(['/aof'], { replaceUrl: true });
                        }
                    }
                },
                error: error => {
                    this.loader.stop();
                    if (!window.navigator.onLine) {
                        // this.toastr.error("It appears that your internet connectivity is slow or please try again.");
                        this.errorComp.ModalShow("It appears that your internet connectivity is slow or please try again.");
                    } else {
                        // this.toastr.error(error.error.Message);
                        this.errorComp.ModalShow(error.error.Message);
                    }
                }
            })
        }
    }

    typeError(event: boolean) {
        this.docError = event;
    }

    getID(id: any) {
        this.foType = id;
    }

    agreeTO() {
        const element = document.getElementById('pdfModal') as HTMLElement;
        this.pdfModal = new Modal(element, { backdrop: 'static', keyboard: false });
        this.pdfModal.show();
    }

    backStage() {
        this.router.navigate(['/bank'])
    }
    IndianCTChange(event: Event) {
        this.IndianCT = (event.target as HTMLInputElement).checked;
    }
    MITCTermsChange(event: Event) {
        this.MITCTerms = (event.target as HTMLInputElement).checked;
    }
    politicallyChange(event: Event) {
        this.politically = (event.target as HTMLInputElement).checked;
    }
    PreferencesChange(event: Event) {
        this.Preferences = (event.target as HTMLInputElement).checked;
    }
    settledChange(event: Event) {
        this.settled = (event.target as HTMLInputElement).checked;
    }
    FundSettleDaysChange(event: Event) {
        this.FundSettleDays = (event.target as HTMLInputElement).value;
    }
    NextValidate() {
        if ( !this.MITCTerms  || !this.Preferences ) {
            this.errorComp.ModalShow("Please accept the terms and conditions");
            return;
        } else {
            this.termsStage = false;
        }
    }
    prefer() {
        this.Preferences =true;
        const element = document.getElementById('tradePR') as HTMLElement;
        this.trade = new Modal(element, { backdrop: 'static', keyboard: false });
        this.trade.show();
    }
    MitcTm(){
        this.MITCTerms = true;
         const element = document.getElementById('MitcT') as HTMLElement;
        this.mitc = new Modal(element, { backdrop: 'static', keyboard: false });
        this.mitc.show();
    }



}